import { render, staticRenderFns } from "./config024-a-music.vue?vue&type=template&id=44eb8b01&"
import script from "./config024-a-music.vue?vue&type=script&lang=js&"
export * from "./config024-a-music.vue?vue&type=script&lang=js&"
import style0 from "./config024-a-music.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports